module.exports = __webpack_public_path__ + "static/media/a52.a12cec1c.jpg";